import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=25def5db"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25def5db')) {
      api.createRecord('25def5db', component.options)
    } else {
      api.reload('25def5db', component.options)
    }
    module.hot.accept("./UserItem.vue?vue&type=template&id=25def5db", function () {
      api.rerender('25def5db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/groupList/component/UserItem.vue"
export default component.exports